// Auth Data

export default {
  title: {
    label: 'Наименование гайда',
    value: '',
    type: 'text',
    error: null,
    min: 3,
    max: 100,
    req: /[A-Za-zА-Яа-я0-9]/,
    validate: true
  },
  url: {
    label: 'URL',
    value: '',
    type: 'text',
    error: null,
    min: 3,
    max: 100,
    req: /^[a-za-z]+$/,
    validate: true
  },
  price: {
    label: 'Стоимость',
    value: '',
    type: 'number',
    error: null,
    min: 0,
    max: 9999999,
    req: /[^+\d]/g,
    validate: true
  },
  newprice: {
    label: 'Стоимость гайда дня (Стоимость со скидкой)',
    value: '',
    type: 'number',
    error: null,
    min: 0,
    max: 9999999,
    req: /[^+\d]/g,
    validate: true
  },
  budget: {
    label: 'Бюджет',
    value: '',
    type: 'number',
    error: null,
    min: 0,
    max: 9999999,
    req: /[^+\d]/g,
    validate: true
  },
  pages: {
    label: 'Кол-во страниц',
    value: '',
    type: 'number',
    error: null,
    min: 0,
    max: 9999999,
    req: /[^+\d]/g,
    validate: true
  },
  period: {
    label: 'Кол-во дней',
    value: '',
    type: 'number',
    error: null,
    min: 0,
    max: 9999999,
    req: /[^+\d]/g,
    validate: true
  },
  category: {
    label: 'Категория',
    placeholder: 'Выберите значение',
    value: '',
    type: 'select',
    items: [
      { value: 0, name: 'Не указывать' },
      { value: 1, name: 'Море' },
      { value: 2, name: 'Природа' },
      { value: 3, name: 'Города' },
      { value: 3, name: 'Из Москвы' }
    ],
    error: null,
    min: null,
    max: null,
    req: null,
    required: false,
    validate: false,
    special: true,
    specialKey: 'special',
    specialDefault: {
      value: null,
      name: 'Special'
    }
  },
  points: {
    label: 'Кол-во точек',
    value: '',
    type: 'number',
    error: null,
    min: 0,
    max: 9999999,
    req: /[^+\d]/g,
    validate: true
  },
  pdf: {
    label: 'Pdf файл',
    placeholder: 'Выберите файл',
    value: null,
    type: 'file',
    error: null,
    min: null,
    max: null,
    req: null,
    validate: false
  },
  imageContent: {
    label: 'Картинка "Содержание"',
    placeholder: 'Выберите файл',
    accept: '.jpg,.jpeg,.png,.webp',
    value: null,
    type: 'file',
    error: null,
    min: null,
    max: null,
    req: null,
    validate: false
  },
  imageMaproutes: {
    label: 'Картинка "Карта с маршрутами"',
    placeholder: 'Выберите файл',
    accept: '.jpg,.jpeg,.png,.webp',
    value: null,
    type: 'file',
    error: null,
    min: null,
    max: null,
    req: null,
    validate: false
  },
  description: {
    label: 'Описание',
    value: '',
    type: 'editor',
    error: null,
    min: null,
    max: 1000,
    req: null,
    validate: false
  },
  gallery: {
    type: 'images',
    req: '.jpg,.jpeg,.png,.webp',
    max: 20,
    value: []
  },
  reviews: {
    type: 'images',
    req: '.jpg,.jpeg,.png,.webp',
    max: 20,
    value: []
  },
  flipchart: {
    type: 'images',
    req: '.jpg,.jpeg,.png,.webp',
    max: 20,
    value: []
  },
  flipchart2: {
    type: 'images',
    req: '.jpg,.jpeg,.png,.webp',
    max: 20,
    value: []
  },
  cover: {
    label: 'Обложка',
    value: null,
    type: 'number',
    error: null,
    min: null,
    max: null,
    req: null,
    validate: false,
    disabled: true
  },
  special: {
    label: 'Special',
    value: false,
    type: 'number',
    error: null,
    min: null,
    max: null,
    req: null,
    validate: false,
    disabled: true
  },
}
